import { useStyletron } from 'baseui';
import React from 'react';
import * as meta from '../../meta-data.json';
import { Tooltip } from '../Tooltip';
import { BadgeStyles, NotificationBadgeStyles } from './styles';
import { IBadgeProps } from './types';

export const View = (props: IBadgeProps & { rootref: any }) => {
	const { rootref, className, disabled = false, theme = 'grey', size = 'default', ...rest } = props;

	const determinateSize = ['mini', 'compact'].includes(size) ? 'compact' : 'default';

	const [css] = useStyletron();
	const classNames = className
		? css(BadgeStyles(theme, disabled, determinateSize, rest)) + ' ' + className
		: css(BadgeStyles(theme, disabled, determinateSize, rest));

	return (
		<span data-epo={`epo-badge-${meta.version}`} ref={rootref} className={classNames} {...rest}>
			{props.children}
		</span>
	);
};

export const NotificationBadge = (props: IBadgeProps & { rootref: any }) => {
	const { rootref, className, size = 'default', tooltipPlacement = 'auto' } = props;
	const [css] = useStyletron();

	const classNames = className
		? css(NotificationBadgeStyles(size)) + ' ' + className
		: css(NotificationBadgeStyles(size));

	return (
		<Tooltip content={props.children} placement={tooltipPlacement}>
			<span data-epo={`epo-dot-badge-${meta.version}`} ref={rootref} className={classNames}></span>
		</Tooltip>
	);
};
